import { render, staticRenderFns } from "./FeedItemActionMsg.vue?vue&type=template&id=13d79ece&scoped=true&"
import script from "./FeedItemActionMsg.vue?vue&type=script&lang=js&"
export * from "./FeedItemActionMsg.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemActionMsg.vue?vue&type=style&index=0&id=13d79ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d79ece",
  null
  
)

export default component.exports